import * as request from '@/utils/request'
let BaseUrl = '/paas/idcard/whitelist'
export default {
	// --------------------------------------  下发年龄白名单 -------------------------------------------
	/**
	 * @description 删除白名单
	 * @author daihua
	 * @date 2022/3/7
	 * @param {*} data
	 * @returns 
	 */
	deleteAgewhiteId(id) {
		return request.Delete(`${BaseUrl}/delete/${id}`)
	},
	/**
	 * @description 增加白名单
	 * @author daihua
	 * @date 2022/3/7
	 * @param {*} data
	 * @returns 
	 */
	postCreateAgewhite(data) {
		return request.post(`${BaseUrl}/create`, data)
	},
	/**
	@description 白名单列表
	* @author daihua
	* @date 2022/3/7
	* @param {*} data
	* @returns 
	 */
	postAgewhiteList(data) {
		return request.post(`${BaseUrl}/list`, data)
	},


}
